import { Button, FormControl, Modal, TextField } from "@mui/material";
import { useParams } from "react-router-dom"
import ContainerModal from "../../../../../components/modalExportar/components/containerModal";
import { useForm } from "react-hook-form";
import useNav from "../../../../../hooks/useNav";
import api from "../../../../../utils/api";
import { useEffect } from "react";
import useLoading from "../../../../../hooks/useLoading";
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";

export type TSede = {
    id: number,
    grupo: {
        id: number,
        descricao: string
    },
    social: string,
    nomefantasia: string,
    cnpj: string,
    telefone: string,
    cidade: {
        id: number,
        ibge: number,
        descricao: string,
        uf: string
    },
    cep: string,
    rua: string,
    bairro: string,
    abertura: string,
    fim: string,
    qtdmembro: number
    numero: string
}

export type PutSede = {
    "id": number,
    "grupo": number,
    "social": string,
    "nomefantasia": string,
    "cnpj": string,
    "telefone": string,
    "cidade": number,
    "nome_cidade": string,
    "cep": string,
    "rua": string,
    "numero": string,
    "bairro": string,
    "abertura": string,
    "fim": string
}

export const EditSede = () => {

    const { id } = useParams();

    const { goBack } = useNav();

    const { startLoading, stopLoading, isLoading } = useLoading();

    const { setMensagemSuccess, setMensagemError } = useErrorSuccess();

    const getGrupoSede = async () => {
        let req = await api.get<TSede>('sede/geral/' + id);

        setValue('bairro', req?.data?.bairro)
        setValue('grupo', req?.data?.grupo?.id)
        setValue('abertura', req?.data?.abertura)
        setValue('fim', req?.data?.fim)
        setValue('cep', req?.data?.cep)
        setValue('cnpj', req?.data?.cnpj)
        setValue('cidade', req?.data?.cidade?.id)
        setValue('nome_cidade', req?.data?.cidade?.descricao)
        setValue('rua', req?.data?.rua)
        setValue('social', req?.data?.social)
        setValue('telefone', req?.data?.telefone)
        setValue('nomefantasia', req?.data?.nomefantasia)
        setValue('numero', req?.data?.numero)

        return;
      }

    const {
        register,
        setValue,
        handleSubmit
    } = useForm<PutSede>()

    useEffect(() => {
        getGrupoSede()
    }, [id, getGrupoSede])

    const post = handleSubmit(async (values) => {
        startLoading();
        try {
            await api.put('sede/geral/'+id, values);
            setMensagemSuccess('Cadastrado com sucesso!');
            goBack();
        } catch(error) {
            setMensagemError(JSON.stringify(error?.response?.data?.mensagem || error?.response?.data, null, 2))
        } finally {
            stopLoading()
        }
    })

    return (
        <>
        <Modal open={true} onClose={goBack}>
        <ContainerModal>
          <FormControl fullWidth>
            <TextField
              {...register('nomefantasia')}
              label="Descrição"
              sx={{ width: '100%', mb: 1 }}
            />
          </FormControl>
          <FormControl fullWidth>
            <TextField
              {...register('cnpj')}
              label="CNPJ"
              sx={{ width: '100%', mb: 1 }}
            />
          </FormControl>
          
          <FormControl fullWidth>
            <TextField
              {...register('telefone')}
              label="Telefone"
              sx={{ width: '100%', mb: 1 }}
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              {...register('cep')}
              label="CEP"
              sx={{ width: '100%', mb: 1 }}
            />
          </FormControl>
          
          <FormControl fullWidth>
            <TextField
              {...register('numero')}
              label="Número"
              sx={{ width: '100%', mb: 1 }}
            />
          </FormControl>
         
          <FormControl fullWidth>
            <TextField
              {...register('rua')}
              label="Rua"
              sx={{ width: '100%', mb: 1 }}
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              {...register('nome_cidade')}
              label="Cidade"
              sx={{ width: '100%', mb: 1 }}
            />
          </FormControl>
          

          <FormControl fullWidth>
            <TextField
              {...register('bairro')}
              label="Bairro"
              sx={{ width: '100%', mb: 1 }}
            />
          </FormControl>
          <div style={{
            display: "flex", marginTop: 8, justifyContent: 'space-between', alignItems: 'center', width: '100%'
          }}>
            <Button variant="contained" color="success" onClick={post} disabled={isLoading}>Salvar</Button>
            <Button variant="contained" color="error" onClick={goBack}>Cancelar</Button>
          </div>
        </ContainerModal>
      </Modal>
        </>
    )
}